import { request } from '@blade/common';
/**
*@Description: 解析查询
*/
export const getSearchQueryAttributesSearch = (data) => request.post(`/api/timedb-management/api/v1/search/query/attributesSearch`, data);
/**
*@Description: 特征属性
*/
export const getSearchQueryAttributes = () => request.get(`/api/timedb-management/api/v1/search/query/attributes`);
/**
*@Description: 告警查询
*/
export const getIncidentRecords = (data) => request.post(`/api/incident-record-management/api/v1/incident/records`, data);
/**
 *@Description: 任务详情
 */
export const getTaskDetail = (data) => request.get(`/api/task-management/api/v1/task/${data}`);
/**
 *@Description: 获取设备
 */
export const getDeviceTree = () => request.post(`/api/camera-device-management/api/v1/device-groups/devices/tree`, {});
